var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "512,483.643 56.713,256 512,28.357 512,0 0,256 512,512 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "56.713,256 512,483.643 512,28.357 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5DC"
    },
    d: "M450.583,211.231c0,0,31.476,1.334,34.41-1.067s3.468-18.406-6.935-20.806  c-10.403-2.401-38.678,13.071-38.678,13.071L450.583,211.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D27D69"
    },
    d: "M388.964,236.039c0,0-0.356,0.889-0.534,4.801c-0.178,3.912,0.534,14.049,12.804,18.495   l-2.845,11.915l12.982,7.825c0,0,9.603-14.227,10.136-26.141C422.041,241.018,388.964,236.039,388.964,236.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D27D69"
    },
    d: "M350.019,228.036l5.068-5.068c0,0-10.375,6.33-14.315,0.622c-5.157-7.469,1.778-15.294,8.98-18.761   c7.202-3.468,21.607-0.8,21.607-0.8l9.069,23.207l-27.475,17.339L350.019,228.036z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D27D69"
    },
    d: "M435.112,183.756l24.541-2.934c0,0-7.202,10.403-21.34,18.139c0,0,14.671,0,18.939,5.068   s-4.268,9.87-7.469,11.47s-30.943,18.672-30.943,18.672l-24.808-2.934L435.112,183.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D27D69"
    },
    d: "M453.339,164.906c0,0,5.335-12.448,5.157-21.162l-17.961,12.448c0,0,4.09-1.956,2.667-9.069   l-58.684,31.832l-11.915,21.162l36.278,11.203L453.339,164.906z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M409.104,261.913l-6.135,9.736c0,0-10.937-2.401-14.671,0.267s-4.135,12.671,2.401,13.471  c0,0,4.535,2.801,7.202,0.534c0,0,5.468,2.134,6.402-1.334s-0.267-6.402-0.267-6.402h3.868l6.802-12.137L409.104,261.913z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B95546"
    },
    d: "M354.287,240.84c0,0,17.072-8.536,17.072-21.34s-15.827-13.515-28.631-9.247  c0,0-7.647-6.046-1.245-12.093c8.776-8.289,46.948-25.608,46.948-25.608l-4.268,21.34c0,0,15.205,8.002,21.34,4.268  c5.156-3.138,55.483-42.68,55.483-42.68s-4.268,21.34-34.144,42.68l-3.166,15.828c-0.695,3.477-2.957,6.439-6.129,8.025  l-12.045,6.022c0,0,34.144,4.268,34.144,8.536c0,4.268-8.536,25.608-25.608,34.144l-8.536-8.536l4.268-12.804  c0,0-12.804-4.268-21.34-8.536c0,0-12.804,4.268-21.34,4.268S354.287,240.84,354.287,240.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5DC"
    },
    d: "M328.679,262.18v-8.868c0-2.52,1.001-4.937,2.783-6.719l18.557-18.557l4.268,8.536h17.072  l-4.268,4.268v4.268l-21.34,12.804L328.679,262.18z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M337.215,257.912h-8.536c0,0-8.536,12.804,0,12.804c0,0,12.804-8.536,17.072-12.804   C345.751,257.912,345.751,253.644,337.215,257.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M441.323,276.844h-59.002c-0.486-0.524-1.167-0.862-1.938-0.862c0,0-10.335-4.283-11.805-4.283   h-1.211c-1.47,0-2.661,1.191-2.661,2.661v2.484h-13.488v-2.484c0-1.47-1.191-2.661-2.661-2.661h-1.211   c-1.47,0-2.661,1.191-2.661,2.661v0.045c-5.781-0.236-18.14-0.972-24.541-3.106L286,279.835l34.144,8.536   c6.401-2.134,18.76-2.871,24.541-3.107v0.045c0,1.469,1.191,2.661,2.661,2.661h1.211c1.47,0,2.661-1.192,2.661-2.661v-2.484h13.488   v2.484c0,1.469,1.192,2.661,2.661,2.661h1.211c1.47,0,11.805-4.283,11.805-4.283c0.771,0,1.451-0.338,1.937-0.862h59.002   c1.652,0,2.991-1.339,2.991-2.991C444.314,278.183,442.975,276.844,441.323,276.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M438.757,288.321c-3.557-0.712-44.28,6.402-44.28,6.402s-2.49-2.49,4.979-9.425l-3.557-0.889   c0,0-7.824,5.513-11.025,6.224c-2.757,0.613-8.915,3.606-10.238,7.604l-24.795,4.133l0.533,2.134l24.321-2.85   c1.161,3.737,4.983,4.498,7.689,3.384c0,0,3.557,1.423,6.758-1.067c0,0,6.402,1.067,6.758-4.801l44.636-6.758   C440.535,292.411,442.314,289.033,438.757,288.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M413.505,318.375c0,0-3.379,4.446-11.737,0.533s-18.139,0.356-23.474-0.889   s-13.337-4.446-20.806-1.6c-7.469,2.845-11.559,2.667-9.959-0.889c1.6-3.557,2.49-6.224,0-7.469l2.845-3.557l-0.533-2.134   c0,0-14.226-5.513-23.829,2.134s-6.758,25.074,9.247,26.319c0,0,4.979,6.224,17.25,4.446c0,0,8.002,5.513,21.695,3.023   c0,0,0.533,1.6,9.425,0.889s18.85,0.356,17.072,6.402c0,0,6.58-1.245,2.667-7.291c0,0,7.825-0.356,13.16,4.268   c0,0,0.356-5.335-4.801-8.18c0,0,8.714-3.023,13.515,0c0,0-3.201-6.758-11.737-5.868c0,0,6.224-4.979,9.069-3.734   c0,0-2.667-3.201-10.492,0C412.082,324.777,417.062,321.754,413.505,318.375z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAs);
export default __webpack_public_path__ + "static/media/AS.a4ca9d8f75169f3774e6db085e82278a.svg";
export { ForwardRef as ReactComponent };